module.exports = __webpack_public_path__ + "static/media/Khyros_logo_design_white.572c1afe.png";